"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_tabs_1 = require("react-tabs");
var controlList_1 = require("./controlList");
var actionList_1 = require("./actionList");
var React = require("react");
var utils_1 = require("../../utils");
var urls_1 = require("../../urls");
var App_1 = require("../../App");
var contexts_1 = require("../../interfaces/contexts");
var TabIndexes = (function () {
    function TabIndexes() {
    }
    TabIndexes.CONTROLS = 0;
    TabIndexes.ACTIONS = 1;
    return TabIndexes;
}());
var ControlActionList = (function (_super) {
    __extends(ControlActionList, _super);
    function ControlActionList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tabIndex: TabIndexes.CONTROLS
        };
        _this.setTabIndex = function (tabIndex) {
            _this.setState({ tabIndex: tabIndex });
        };
        _this.clickControlsHandler = function (event) {
            (0, utils_1.preventDefault)(event);
            history.pushState(null, null, _this.getUrl(urls_1.Urls.control_list));
        };
        _this.clickActionsHandler = function (event) {
            (0, utils_1.preventDefault)(event);
            history.pushState(null, null, _this.getUrl(urls_1.Urls.action_list));
        };
        _this.getUrl = function (url, search) {
            if (search === void 0) { search = true; }
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                var project_id = context.project;
                var location_1 = window.location.search;
                var params = new URLSearchParams(location_1);
                return (0, urls_1.resolve)(url, project_id) + (search ? ("?" + params.toString()) : "");
            }
            else {
                throw new Error("ControlActionList does not support the current context");
            }
        };
        _this.actionsOrControls = function () {
            var controls_url = _this.getUrl(urls_1.Urls.control_list, false);
            var actions_url = _this.getUrl(urls_1.Urls.action_list, false);
            switch (window.location.pathname) {
                case controls_url:
                    return TabIndexes.CONTROLS;
                case actions_url:
                    return TabIndexes.ACTIONS;
                default:
                    return TabIndexes.CONTROLS;
            }
        };
        _this.getVisibleTabs = function () {
            var items = menu_items || [];
            var showAll = items.length === 0;
            var tabs = [];
            if (showAll || items.includes("ca_controls_list")) {
                tabs.push({ key: "controls", index: TabIndexes.CONTROLS, label: get_term("Controls"), url: urls_1.Urls.control_list, onClick: _this.clickControlsHandler });
            }
            if (showAll || items.includes("ca_actions_list")) {
                tabs.push({ key: "actions", index: TabIndexes.ACTIONS, label: gettext("Actions"), url: urls_1.Urls.action_list, onClick: _this.clickActionsHandler });
            }
            return tabs;
        };
        return _this;
    }
    ControlActionList.prototype.componentDidMount = function () {
        this.setTabIndex(this.actionsOrControls());
    };
    ControlActionList.prototype.render = function () {
        var _this = this;
        var visibleTabs = this.getVisibleTabs();
        if (visibleTabs.length === 0) {
            return (React.createElement("div", { className: "alert alert-info" }, gettext("No tabs are enabled for this page.")));
        }
        var selectedIndex = visibleTabs.findIndex(function (t) { return t.index === _this.state.tabIndex; });
        return (React.createElement(react_tabs_1.Tabs, { selectedTabClassName: "active", selectedIndex: selectedIndex >= 0 ? selectedIndex : 0, onSelect: function (index) { var _a, _b; return _this.setTabIndex((_b = (_a = visibleTabs[index]) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : TabIndexes.CONTROLS); } },
            React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs control_list_tabs" }, visibleTabs.map(function (tab) { return (React.createElement(react_tabs_1.Tab, { key: tab.key, className: "nav-item" },
                React.createElement("a", { className: "nav-link", onClick: tab.onClick, href: _this.getUrl(tab.url) }, tab.label))); })),
            visibleTabs.map(function (tab) { return (React.createElement(react_tabs_1.TabPanel, { key: tab.key },
                tab.index === TabIndexes.CONTROLS && React.createElement(controlList_1.default, null),
                tab.index === TabIndexes.ACTIONS && React.createElement(actionList_1.default, null))); })));
    };
    return ControlActionList;
}(React.Component));
exports.default = ControlActionList;
